// React
import React, { useState } from "react";
import { translate, tranStr } from "../../utils/translation";
import PropTypes from "prop-types";
import Modal from "../modal/Modal";
import ProjectControlDrawer from "../project-control/ProjectControlDrawer";
import PostContractPanel from "./PostContractPanel";

import Spinner from "../common/Spinner";
import { onDelete } from "../../api/post-contract/PostContractDeleteAPI";

// Functions
import { hasRoles } from "../../utils/roles";

import { ConfigurableForm } from "./PostContractForm";

import "./PostContractButtons.css";
import isEmpty from "../../validation/is-empty";
import EstimateCommentaryModal from "../estimate-commentary/EstimateCommentaryModal";
import { pc2APIs } from "../../api/api-endpoints/PostContract2.0Endpoints";

// PCRA Components
import PostContractPCRAModalTrigger from "../post-contract-pcra/PostContractPCRAModalTrigger";
import { publishBenchmarkProject } from "../../api/benchmarking/BenchmarkingAPI";
import PostContractKeyDocsUpload from "./PostContractKeyDocs.components";

PostContractButtons.propTypes = {
  projectID: PropTypes.string,
  project: PropTypes.any,
  postContract: PropTypes.object,
  postContractReports: PropTypes.object,
  postContractForm: PropTypes.object,
  selectedReport: PropTypes.object,
  selectedPackage: PropTypes.object,
  packages: PropTypes.object,
  showCRPanel: PropTypes.bool,
  showPCPanel: PropTypes.bool,
  user: PropTypes.object,
  setShowCRPanel: PropTypes.func,
  setShowPCPanel: PropTypes.func,
};

export default function PostContractButtons(props) {
  const { projectID } = props;
  const { project } = props;
  const { postContract } = props;
  const { postContractReports } = props;
  const { postContractForm } = props;

  const { selectedReport } = props;
  const { selectedPackage } = props;
  const { packages } = props;
  const { showCRPanel, setShowCRPanel } = props;
  const { showPCPanel, setShowPCPanel } = props;
  const { user } = props;

  const [showPostContract, setShowPostContract] = useState(false);

  const isProjectPhasePostContract = project.project_phase === "POST_CONTRACT";

  if (
    !hasRoles(user.roles, ["CostManager"]) ||
    !window.location.href.includes("post-contract")
  ) {
    return null;
  }

  //Check if the contract details are entered, if they are empty, disable all the buttons
  let contractDetailsEmpty = !selectedPackage?.HasContractFields;

  return (
    <div className="post-contract-control-panel">
      <div className="post-contract-control-panel-buttons">
        {isProjectPhasePostContract && (
          <>
            <PostContractPanelWrapper
              user={user}
              selectedPackage={selectedPackage}
              project={project}
              selectedReport={selectedReport}
              postContract={postContract}
              postContractForm={postContractForm}
              setShowCRPanel={setShowCRPanel}
              setShowPCPanel={setShowPCPanel}
              showPostContract={showPostContract}
              setShowPostContract={setShowPostContract}
              disabled={contractDetailsEmpty}
            />
            <DashboardPanel
              showDashboard={showCRPanel}
              setShowDashboard={setShowCRPanel}
              setShow2={setShowPostContract}
              label={translate("Cost Report Panel")}
              showLocation={"Cost%20Report"}
              disabled={contractDetailsEmpty}
            />
            <DashboardPanel
              showDashboard={showPCPanel}
              setShowDashboard={setShowPCPanel}
              setShow2={setShowPostContract}
              label={translate("Progress Claim Panel")}
              showLocation={"Progress%20Claim"}
              disabled={contractDetailsEmpty}
            />
            <UploadButton
              user={user}
              projectId={project.id}
              packages={packages}
              postContractReports={postContractReports}
              selectedPackage={selectedPackage}
              showLocation={"Cost%20Report"}
              label={translate("Upload Cost Report")}
              Component={ConfigurableForm}
              disabled={contractDetailsEmpty}
              postContractFormType={"costReportFields"}
              stateUpdateFunction={async () => {
                const URL = window.location.href;
                const sheetName = URL.substring(URL.lastIndexOf("/") + 1);
                postContractReports.set(
                  await postContractReports.get(
                    project.id,
                    selectedPackage.Id,
                    sheetName
                  )
                );
                packages.set(await packages.get(project.id));
              }}
              urlEndpoint={
                pc2APIs().upload_form +
                "?projectId=" +
                project.id +
                "&packageId=" +
                selectedPackage.Id +
                "&uploadType=Cost Report"
              }
              //modal dialog tooltip component's props
              iconText={translate("Information")}
              tooltipIcon={[<InformationTooltipHtml key="creport_toolicon" />]}
              tooltipHtml={[
                <CostReportUploadTooltipHtml key="creport_toolhtml" />,
              ]}
            />
            <UploadButton
              projectId={project.id}
              packages={packages}
              postContractReports={postContractReports}
              selectedPackage={selectedPackage}
              user={user}
              showLocation={"Progress%20Claim"}
              label={translate("Upload Progress Claim")}
              Component={ConfigurableForm}
              postContractFormType={"progressClaimFields"}
              disabled={contractDetailsEmpty}
              stateUpdateFunction={async () => {
                const URL = window.location.href;
                const sheetName = URL.substring(URL.lastIndexOf("/") + 1);
                postContractReports.set(
                  await postContractReports.get(
                    project.id,
                    selectedPackage.Id,
                    sheetName
                  )
                );
                packages.set(await packages.get(project.id));
              }}
              urlEndpoint={
                pc2APIs().upload_form +
                "?projectId=" +
                project.id +
                "&packageId=" +
                selectedPackage.Id +
                "&uploadType=Progress Claim"
              }
              //modal dialog tooltip component's props
              iconText={translate("Information")}
              tooltipIcon={[<InformationTooltipHtml key="pclaim_toolicon" />]}
              tooltipHtml={
                <ProgressClaimUploadTooltipHtml key="pclaim_toolhtml" />
              }
            />
            <EstimateCommentaryModal
              user={user}
              project={project}
              CPs={postContract}
              CP={postContract}
              commentNumber={processComments(
                postContract?.data[0]?.Advice?.Commentary
              )}
              URLs={{
                endpoint: pc2APIs,
                updateStateFunction: async () => {
                  const URL = window.location.href;
                  const sheetName = URL.substring(URL.lastIndexOf("/") + 1);
                  postContract.set(
                    await postContract.get(
                      selectedPackage.ProjectId,
                      selectedReport?.Id,
                      sheetName
                    )
                  );
                },
              }}
              CostId={selectedReport.Id}
              Module="PostContract"
            />

            <PostContractControlDelete
              projectId={projectID}
              selectedPackage={selectedPackage}
              selectedReport={selectedReport}
              postContractReports={postContractReports}
              packages={packages}
            />
          </>
        )}
        <PostContractPCRAModalTrigger
          user={user}
          project={project}
          postContract={postContract}
          selectedReport={selectedReport}
        />
        <PostContractKeyDocsUpload
          user={user}
          project={project}
          selectedReport={selectedReport}
          postContract={postContract}
        />
      </div>
    </div>
  );
}

PostContractPanelWrapper.propTypes = {
  user: PropTypes.object,
  selectedPackage: PropTypes.object,
  setSelectedPackage: PropTypes.func,
  selectedReport: PropTypes.object,
  showPostContract: PropTypes.bool,
  postContract: PropTypes.object,
  setShowPostContract: PropTypes.func,
  setShowCRPanel: PropTypes.func,
  setShowPCPanel: PropTypes.func,
  postContractForm: PropTypes.object,
  project: PropTypes.object,
  disabled: PropTypes.bool,
};

export function PostContractPanelWrapper(props) {
  const { user } = props;
  const { selectedPackage } = props;
  const { selectedReport } = props;
  const { showPostContract } = props;
  const { postContract } = props;
  const { setShowPostContract } = props;
  const { setShowCRPanel } = props;
  const { setShowPCPanel } = props;
  const { postContractForm } = props;
  const { project } = props;
  const { disabled } = props;

  if (
    !window.location.href.includes("dashboard") &&
    !window.location.href.includes("Cost%20Report") &&
    !window.location.href.includes("Progress%20Claim")
  ) {
    return null;
  }
  if (disabled) {
    return null;
  }

  let title = "";
  if (window.location.href.includes("dashboard")) {
    title = tranStr("Post Contract Control");
  }
  if (window.location.href.includes("Cost%20Report")) {
    title = tranStr("Cost Report Control");
  }
  if (window.location.href.includes("Progress%20Claim")) {
    title = tranStr("Progress Claim Control");
  }

  return (
    <ProjectControlDrawer
      Component={PostContractPanel}
      dashboardType={"POST_CONTRACT"}
      dashboardSelect={"POST_CONTRACT"}
      user={user}
      project={project}
      selectedReport={selectedReport}
      selectedPackage={selectedPackage}
      postContract={postContract}
      postContractForm={postContractForm}
      label={title}
      show1={showPostContract}
      setShow1={setShowPostContract}
      setShow2={setShowCRPanel}
      setShow3={setShowPCPanel}
      setShow4={setShowPCPanel}
      {...props}
    />
  );
}

DashboardPanel.propTypes = {
  showDashboard: PropTypes.bool,
  setShowDashboard: PropTypes.func,
  setShow2: PropTypes.func,
  label: PropTypes.any,
  showLocation: PropTypes.string,
  disabled: PropTypes.bool,
};

export function DashboardPanel(props) {
  const { showDashboard } = props;
  const { setShowDashboard } = props;
  const { setShow2 } = props;
  const { label } = props;
  const { showLocation } = props;
  const { disabled } = props;

  if (!window.location.href.includes(showLocation)) {
    return null;
  }

  if (disabled) {
    return null;
  }

  let classType = "post-contract-control-button-dashboard";
  if (showDashboard) {
    classType = "post-contract-control-button-clicked";
  }

  return (
    <button
      className={classType}
      onClick={() => {
        setShowDashboard(!showDashboard);
        setShow2(false);
      }}
    >
      {label}
    </button>
  );
}

UploadButton.propTypes = {
  label: PropTypes.any,
  showLocation: PropTypes.string,
  disabled: PropTypes.bool,
  selectedPackage: PropTypes.object,
};

export function UploadButton(props) {
  const { showLocation } = props;
  const { label } = props;
  const { disabled } = props;
  const { selectedPackage } = props;

  const [modal, setModal] = useState(false);

  if (!window.location.href.includes(showLocation)) {
    return null;
  }

  if (disabled || selectedPackage?.IsAggregation) {
    return null;
  }

  return (
    <div>
      <button
        className="post-contract-control-button-upload"
        onClick={() => {
          setModal(true);
        }}
      >
        {label}
      </button>
      <Modal
        title={label}
        modal={modal}
        setModal={setModal}
        setShow={setModal}
        {...props}
      />
    </div>
  );
}

PublishButton.propTypes = {
  benchmarkId: PropTypes.string,
  setParentErrors: PropTypes.func,
};

export function PublishButton(props) {
  const { benchmarkId } = props;
  const { setParentErrors } = props;
  const [disabled, setDisabled] = useState(false);
  return (
    <div>
      <button
        disabled={disabled}
        className="general-upload-button"
        onClick={async () => {
          setParentErrors({
            text: "Publishing...",
            type: "feedback-success",
          });

          setDisabled(true);

          const res = await publishBenchmarkProject(benchmarkId);
          if (isEmpty(res)) {
            setParentErrors({
              text: "Publish Failed",
              type: "feedback-error",
            });
          } else {
            setParentErrors({
              text: "Published Successfully",
              type: "feedback-success",
            });
          }
          setDisabled(false);
        }}
      >
        {"Publish"}
      </button>
    </div>
  );
}

processComments.propTypes = {
  CP: PropTypes.object,
};

export function processComments(CP) {
  // No Commentary so the Comment is number 1
  // The comment is the next in the list
  return isEmpty(CP) || isEmpty(CP.costreport_commentary)
    ? 1
    : CP.costreport_commentary.length + 1;
}

PostContractControlDelete.propTypes = {
  selectedPackage: PropTypes.object,
  projectId: PropTypes.string,
  selectedReport: PropTypes.object,
  postContractReports: PropTypes.any,
};

export function PostContractControlDelete(props) {
  const { projectId } = props;
  const { selectedPackage } = props;
  const { selectedReport } = props;
  const { postContractReports } = props;

  const [loading, setLoading] = useState(false);

  //Do not show the delete button if the package is an aggregation
  if (isEmpty(selectedReport?.Id) || selectedPackage.IsAggregation) {
    return null;
  }
  const data = {
    projectId: projectId,
    packageId: selectedPackage.Id,
    postContractId: selectedReport?.Id,
    postContractReports: postContractReports,
  };

  return (
    <DeleteButton
      data={data}
      label={"Delete Report"}
      loading={loading}
      setLoading={setLoading}
      onDelete={onDelete}
      {...props}
    />
  );
}

DeleteButton.propTypes = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onDelete: PropTypes.func,
  label: PropTypes.string,
  data: PropTypes.object,
  packages: PropTypes.object,
  selectedReport: PropTypes.object,
};

function DeleteButton(props) {
  const { loading, setLoading } = props;
  const { onDelete } = props;
  const { label } = props;
  const { data } = props;
  const { packages, selectedReport } = props;
  if (loading) {
    return <Spinner width={50}></Spinner>;
  } else {
    return (
      <button
        className={
          selectedReport?.pcra_log?.isPublished
            ? "post-contract-control-button-delete disabled"
            : "post-contract-control-button-delete"
        }
        onClick={() => {
          setLoading(true);
          onDelete(data).then(async () => {
            packages.set(await packages.get(data.projectId));
            setLoading(false);
          });
        }}
      >
        {translate(label)}
      </button>
    );
  }
}
export function ProgressClaimUploadTooltipHtml(props) {
  return (
    <div>
      <p>
        Please note that all manually entered general Dashboard Commentary will
        be copied forward and may require updating.
      </p>
      <p>
        Updating a Progress Claim will also create a draft Cost Report and this
        will be visible to clients when the PCA process has been completed.
        Draft Cost Reports can be toggled off in the toggle features menu.
      </p>
    </div>
  );
}
export function InformationTooltipHtml() {
  return <i key="progress-claim-info-icon" className="fas fa-info-circle" />;
}
export function CostReportUploadTooltipHtml(props) {
  return (
    <div>
      <p>
        Please note that all manually entered general Dashboard Commentary will
        be copied forward and may require updating.
      </p>
    </div>
  );
}
